
import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { IFollowup, ILang } from "@models/*";
import { Constants, Dictionary, moment, queryString, Enums } from "@utils";
import { FollowupService, IFollowupService } from "@services/proyecta/followup.service";


export class FollowupSubprojectParentPresenter extends BasePresenter<any> {
    public currentLabels: Dictionary<string, string>;
    public followupLabels: Dictionary<string, string>;
    public formMasters: any;
    public followupData: IFollowup[];
    public subProjectDimensions: any[];
    public currentLang: ILang;
    private followupService: IFollowupService;
    public params: any;
    
    constructor(view: any) {
        super(view);
        this.followupData = useSelector(this.context.followupStore.selectFollowupData);
        this.subProjectDimensions = useSelector(this.context.followupStore.selectSubProjectDimensions);
        this.formMasters = useSelector(this.context.followupStore.selectFormMasters);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
        this.followupLabels = useSelector(this.context.followupStore.selectLabels);
        this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;
        this.params = useSelector(this.context.sessionStore.selectParams);
       
        this.followupService = new FollowupService();
    }

    public async initialize(){ 
        this.dispatcherProgress(40);
        this.dispatcherPendingLoad(1);
        this.dispatcherSetLoading();

        this.dispatcherProgress(50);  

        if(!this.followupLabels?.values?.length) this.dispatcher(this.context.followupStore.getLabels());
        
        this.dispatcher(this.context.followupStore.getFollowupData()); 

        this.dispatcherProgress(60);            

        this.dispatcher(this.context.followupStore.getAllFormMasters()); 
        const columns = await this.followupService.getDefinitionColumnsIndex(this.currentLang?.id);
        this.view.state.setDataColumns(columns || []);
        
        this.dispatcherProgress(80);  
    }

    public async clear(){
        this.dispatcher(this.context.followupStore.getFollowupData(true))
    }

    public getParamId(){
        const query = queryString.parseUrl(window.location.href.replace('#', '')).query as any;
        return query.Id
    }

    public getTotalPermissions(projectData: any){
        const TEAM_CENTRAL = this.params[Enums.Params.proyectaCentralTeam]
        const ADMIN_GROUP = this.params[Enums.Params.proyectaAdminModule]
        
        let countryRegionGroup: string = [...this.formMasters.countries, ...this.formMasters.regions].find((cr: any) => cr.Title === projectData?.country )?.SGGrupoAD
        let userGroupsId: any[] = this?.currentUser?.userGroups?.map((x: any) => x.id)
        let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)

        return (userGroupsName?.includes(TEAM_CENTRAL) || userGroupsName?.includes(ADMIN_GROUP) || userGroupsId?.includes(countryRegionGroup))
    }

    public async getData(){ 
        let data = this.followupData.find(x => x.Id?.toString() === this.getParamId())
        
        if(!!data){
            let idsFinancers = data.IdFinanciador?.split(", ")
            let findSubCode = null
            if(!!idsFinancers) findSubCode = idsFinancers.map((y: any) => this.formMasters.allFinancers.find((x: any) => x.Id === Number(y))?.Title).join(", ")
            let country = !!data.IdPais 
                ? this.formMasters.countries.find((x: any) => x.Id === Number(data.IdPais))?.Title 
                : this.formMasters.regions.find((x: any) => x.Id === Number(data.IdRegion))?.Title || ''
            let intLine = this.formMasters.interventionLines.find((x: any) => x.Id === Number(data.IdLineaIntervencion))

            this.view.state.setProjectData({
                id: data.Id,
                projectCode: data.PPresCodProy?.trim(),
                projectTitle: data.TituloProyecto?.trim(), 
                subProject: `${data.CodigoSubvencion ||  this.followupLabels.get("subprojectFFRR")} - ${findSubCode || ''}`, 
                year: data.Anio,
                allow: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.Title,
                allowCode: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.OCTAVIACodigo,
                country,
                intLineCode: intLine?.OCTAVIACodigo || '',
                intLineTitle: intLine?.Title || '',
                status: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoSubproyecto))?.Title,
                startDate: moment.utc(new Date(data.OCTAVIAFechaInicio)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                endDate: moment.utc(new Date(data.OCTAVIAFechaFinalizacion)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                projectId: data.IdProyecto,
                subvCode: data.CodigoSubvencion || '',
                financer: findSubCode || ''
            })
        }
    }

    public async fixMissedActIndicatorsData(data: any) {

        let currUser = this.currentUser.currentUser.userPrincipalName

        for (const item of data){
            let actResultData: any = {...item?.actResultData}
            try {
                actResultData.IndicadorActividadAnioId = item.indicadorActividadAnio
                await this.followupService.fixActIndicatorsData(Enums.ListTypes.SeguimientoActividades, actResultData, currUser)
            } catch(error) {
                console.log(error)
            }
        }

    }

    public async fixMissedActFinancialData(data: any) {

        let currUser = this.currentUser.currentUser.userPrincipalName

        for (const item of data){
            let actResultData: any = {...item?.actResultData}
            try {
                actResultData.IndicadorActividadAnioId = item.indicadorActividadAnio
                await this.followupService.fixActFinancialData(Enums.ListTypes.FinancieraResultadosEsperados, actResultData, currUser)
            } catch(error) {
                console.log(error)
            }
        }

    }

    public async fixMissedActBeneficiariesData(data: any) {

        let currUser = this.currentUser.currentUser.userPrincipalName

        for (const item of data){
            let actResultData: any = {...item?.actResultData}
            try {
                actResultData.IndicadorActividadAnioId = item.indicadorActividadAnio
                await this.followupService.fixActBeneficiariesData(Enums.ListTypes.BeneficiariesByResult, actResultData, currUser)
            } catch(error) {
                console.log(error)
            }
        }

    }

}

export default FollowupSubprojectParentPresenter;